import React, { useState, useCallback } from 'react';
import IntersectionObserver from '@researchgate/react-intersection-observer';

import advice from 'src/types/advice';
import 'src/components/Advice.scss';
import PropTypes from 'prop-types';


const AdviceImage = ({ imageUrl }) => {
  const [sourceImageUrl, setSourceImageUrl] = useState('');
  const observerCallback = useCallback(({ isIntersecting }, unobserve) => requestIdleCallback(() => {
    if (isIntersecting) {
      setSourceImageUrl(imageUrl);
      unobserve();
    }
  }), [imageUrl]);

  return (
    <IntersectionObserver onChange={ observerCallback } rootMargin="100px">
      <img alt="" aria-hidden="true" src={ sourceImageUrl } styleName="picture__image" />
    </IntersectionObserver>
  );
};

const Advice = ({
  title, lead, url, imageUrl
}) => {
  const renderImage = () => (
    <a href={ url } title={ title }>
      <picture styleName="picture">
        <AdviceImage imageUrl={ imageUrl } />
      </picture>
    </a>
  );

  const renderDescription = () => (
    <figcaption>
      <a data-test="anchor-advice" href={ url } styleName="description__anchor" title={ title }>
        <h4 styleName="description__headline">{ title }</h4>
        <h5 styleName="description__subline">{ lead }</h5>
      </a>
    </figcaption>
  );

  return (
    <figure styleName="advice">
      { renderImage() }
      { renderDescription() }
    </figure>
  );
};

AdviceImage.propTypes = {
  imageUrl: PropTypes.string.isRequired
};

Advice.propTypes = advice;


export default Advice;
